module.exports = __webpack_public_path__ + "static/media/md-flame.64a3f009.svg";